// JavaScript Document

jQuery(function ($) {
    
    
    //------------------------------
    //slider
    //------------------------------
    
    $(".js-bnr-slide").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 600,
        //cssEase: 'easeOutBack',
        // 前ボタンの要素を変更 [初期値:'<button type="button" class="slick-prev">Previous</button>']
        prevArrow: '<div class="slick-prev"></div>',
        // 次ボタンの要素を変更 [初期値:'<button type="button" class="slick-next">Next</button>']
        nextArrow: '<div class="slick-next"></div>',
        centerMode: true,
        variableWidth: true, // 横幅がバラバラなスライドにするか
        dots: false,
        touchThreshold: 100,
        initialSlide: 1,
        /*
        //ドットを画像に変える（要css設定と	dots: true）
        	customPaging: function(slick,index) {
        					// スライダーのインデックス番号に対応した画像のsrcを取得
        					var targetImage = slick.$slides.eq(index).find('img').attr('src');
        					//slick-dots > li の中に上記で取得した画像を設定
        					return '<img src=" ' + targetImage + ' "/>';
        				},
        */
        responsive: [{
            breakpoint: 768, // 〜767px
            settings: {
                infinite: true,
                arrows: false,
            }
        }],
    });
    
    $(".js-bnr-slide-mid").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 600,
        //cssEase: 'easeOutBack',
        // 前ボタンの要素を変更 [初期値:'<button type="button" class="slick-prev">Previous</button>']
        prevArrow: '<div class="slick-prev"></div>',
        // 次ボタンの要素を変更 [初期値:'<button type="button" class="slick-next">Next</button>']
        nextArrow: '<div class="slick-next"></div>',
        centerMode: true,
        variableWidth: true, // 横幅がバラバラなスライドにするか
        dots: false,
        touchThreshold: 100,
        initialSlide: 0,
        /*
        //ドットを画像に変える（要css設定と	dots: true）
        	customPaging: function(slick,index) {
        					// スライダーのインデックス番号に対応した画像のsrcを取得
        					var targetImage = slick.$slides.eq(index).find('img').attr('src');
        					//slick-dots > li の中に上記で取得した画像を設定
        					return '<img src=" ' + targetImage + ' "/>';
        				},
        */
        responsive: [{
            breakpoint: 768, // 〜767px
            settings: {
                infinite: true,
                arrows: false,
            }
        }],
    });
    
    
    
    var jsBnrSlideSpOnly = $('.js-bnr-slide-sp-only'); 
    var jsBnrSlideSpOnlyOptions = {
        // スライダーのオプション
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 600,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        centerMode: true,
        variableWidth: true, // 横幅がバラバラなスライドにするか
        dots: false,
        touchThreshold: 100,
        initialSlide: 1,
        responsive: [{
            breakpoint: 768, // 〜767px
            settings: {
                infinite: true,
                arrows: false,
            }
        }],
    };

    function initializeSlickJsBnrSlideSpOnlyOptions() {
        if ($(window).width() < 768) { // 768px以上の時にスライダーを適用
            if (!jsBnrSlideSpOnly.hasClass('slick-initialized')) {
                jsBnrSlideSpOnly.slick(jsBnrSlideSpOnlyOptions);
            }
        } else { // 768px以下の時はスライダーを解除
            if (jsBnrSlideSpOnly.hasClass('slick-initialized')) {
                jsBnrSlideSpOnly.slick('unslick');
            }
        }
    }
    
    
    var slickSlider = $('.js-bnr-slide-feature'); 
    var slickOptions = {
        // スライダーのオプション
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 600,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        centerMode: true,
        variableWidth: true, // 横幅がバラバラなスライドにするか
        dots: false,
        touchThreshold: 100,
        initialSlide: 0,
    };

    function initializeSlick() {
        if ($(window).width() > 767) { // 768px以上の時にスライダーを適用
            if (!slickSlider.hasClass('slick-initialized')) {
                slickSlider.slick(slickOptions);
            }
        } else { // 768px以下の時はスライダーを解除
            if (slickSlider.hasClass('slick-initialized')) {
                slickSlider.slick('unslick');
            }
        }
    }

    // ページロード時に初期化
    initializeSlick();
    initializeSlickJsBnrSlideSpOnlyOptions();

    // ウィンドウリサイズ時に初期化
    $(window).resize(function() {
        initializeSlick();
        initializeSlickJsBnrSlideSpOnlyOptions();
    });
    
    
    $(".js-slide-recommend").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 600,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        centerMode: false,
        variableWidth: true, // 横幅がバラバラなスライドにするか
        dots: false,
        touchThreshold: 100,
        responsive: [{
            breakpoint: 768, // 〜767px
            settings: {
                infinite: true,
                arrows: false,
                centerMode: true,
            }
        }],
    });
    
    
    $(".js_product_image").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 400,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        centerMode: true,
        variableWidth: true, // 横幅がバラバラなスライドにするか
        dots: true,
        touchThreshold: 100,
        //ドットを画像に変える（要css設定と	dots: true）
        customPaging: function(slick,index) {
            // スライダーのインデックス番号に対応した画像のsrcを取得
            var targetImage = slick.$slides.eq(index).find('img').attr('src');
            //slick-dots > li の中に上記で取得した画像を設定
            return '<img src=" ' + targetImage + ' "/>';
        },
        responsive: [{
            breakpoint: 768, // 〜767px
            settings: {
                arrows: false,
            }
        }],
    });
    
    //------------------------------
    //高さをそろえる
    //------------------------------
    
    jsMh();
    
    $(window).resize(function() {
        jsMh();
    });
    
    function jsMh() {
        $('.js-mh-01').matchHeight({
            byRow: true,
        });
        $('.js-mh-02').matchHeight({
            byRow: true,
        });
        $('.js-mh-03').matchHeight({
            byRow: true,
        });
    }
    
       
    //------------------------------
    //ハンバーガーメニュー
    //------------------------------
    
    $("#menu_btn").click(function () {
        $(this).toggleClass("_open");
        $('body').toggleClass("_menu_open");
        setTimeout(function () {
            $('body').toggleClass("_orverflow");
        }, 400);
    });
    
    $("#over_ray").click(function () {
        $("#menu_btn").removeClass("_open");
        $('body').removeClass("_menu_open");
        setTimeout(function () {
            $('body').removeClass("_orverflow");
        }, 400);
    });
    
    
    //------------------------------
    //スムーススクロール
    //------------------------------

    // #がリンクに含まれている場合にアドレスバーのURLに追記
    $('a[href*="#"]').click(function (e) {
        e.preventDefault();

        var headerHight = $('.header').outerHeight() * -1;
        var speed = 1000;
        var href = $(this).attr("href");
        var url = location.protocol + '//' + location.hostname + location.pathname;

        // 現在のURLから既存のハッシュを削除
        href = href.replace(url, '');
        var currentUrl = window.location.href.split('#')[0];  // ハッシュを取り除く
        var newUrl = currentUrl + href;  // 新しいURLを組み立てる

        // ブラウザのURLを更新（履歴に追加）
        history.pushState(null, null, newUrl);

        // ページを再読み込み
        location.reload();

        return false;
    });

    //アンカーリンクをスムーススクロール  
	var hash = location.hash;
	if(hash){
		$("html, body").stop().scrollTop(0);
		setTimeout(function(){
      var headerHight = $('.header').outerHeight();
			var target = $(hash),
			position = target.offset().top - headerHight;
			$("html, body").animate({scrollTop:position}, 800, "swing");
		},301);
	}

});








